import { useQuery } from "@tanstack/react-query";
import { TbUsers } from "react-icons/tb";
import { Link } from "react-router-dom";
import { handleFetchUsersCount } from "../../api/users";

export default function ManageUsers() {
  const { data: count } = useQuery({
    queryKey: ["userCount"],
    queryFn: handleFetchUsersCount,
  });
  return (
    <Link
      to={`/users`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2 bg-white p-4 rounded-md border`}

    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <TbUsers color="#323232" size={24} />
          <div className="mx-2">System Users</div>
          </div>
        </div>
        <div className="font-bold">{count}</div>
      </div>
    </Link>
  );
}
